import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { get } from "common/helpers/HTTP";
import type { EmailOutreachType } from "common/types";

type SourceType = "campaigns" | "lists";

async function getCrmSourcesRequest(
  workspaceId: string,
  type: EmailOutreachType,
  sourceType: SourceType,
): Promise<{ id: string; name: string }[]> {
  return (
    await get(`workspaces/${workspaceId}/integrations/${type}/${sourceType}`)
  )[sourceType];
}

export default function useCrmSources({
  type,
  sourceType,
}: {
  type: EmailOutreachType;
  sourceType: SourceType;
}) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { data: crmSources, isLoading: iseLoadingCrmSources } = useQuery({
    queryKey: [workspaceId, "crmSources", type, sourceType],
    queryFn: () => getCrmSourcesRequest(workspaceId, type, sourceType),
  });

  return {
    crmSources,
    iseLoadingCrmSources,
  };
}
